
function SdDashboardQuotesCtrl(TranslationService, StoreService) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();


    ctrl.openDetail = function (item, ev) {
        console.log('Dashboard.openDetail');
        var modalInstance = StoreService.openOrderDetailModal(item.OrderID);
        modalInstance.result.then(function (order) {
            if (order && order.StatusID) {
                item.StatusID = order.StatusID;
            }
        });
    };

    ctrl.getSitPortalClass = function (sitPortal, statusID) {
        //console.log('getSitPortalClass ' + statusID);
        return StoreService.getSitPortalClass(sitPortal, statusID);
    };
}

SdDashboardQuotesCtrl.$inject = ['TranslationService', 'StoreService'];

seedWebApp.component('sdDashboardQuotes', {
    controller: SdDashboardQuotesCtrl,
    bindings: {
        quotes: '<',
    },
    templateUrl: '/SPA/Quotes/sd-dashboard-quotes.html' + seedWebApp.buildVersion
});